import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { routes } from './app.routes';
import { provideTranslateService} from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

// ============================================================
// JADHU — Browser App Config (Angular 18 SSR)
// ============================================================
export const appConfig: ApplicationConfig = {
  providers: [
    // Zone.js change detection — coalescing reduces unnecessary CD cycles
    provideZoneChangeDetection({ eventCoalescing: true }),

    // Router — with smooth scroll restoration + view transitions API
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
      withViewTransitions(),
    ),

    // SSR Hydration — withEventReplay captures events during hydration
    // provideClientHydration(withEventReplay()),


    // HTTP with fetch API (required for SSR compatibility)
    provideHttpClient(withFetch()),

      provideTranslateService({

      lang: 'en',

      fallbackLang: 'en',

      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json'
      })

    })
  ],
};
